export const iconFontAwesomeHumanitarianPersonRifle = (
	<i className="fa-solid fa-person-rifle"></i>
);
